const ACCESS_TOKEN = 'access';
const REF_TOKEN = 'refresh';
const ID = 'id';

/** set access and refresh token */
export const setSessionAuth = (data) => {
  sessionStorage.setItem(ACCESS_TOKEN, data.access);
  sessionStorage.setItem(REF_TOKEN, data.refresh);
};

/**get access token */
export const getSessionToken = () => {
  const token = sessionStorage.getItem(ACCESS_TOKEN) || null;

  return token;
};

/** */
export const setUserID = (id) => {
  sessionStorage.setItem(ID, id);
};

export const getUserID = () => {
  return sessionStorage.getItem(ID);
};
